import request from '@/util/request'

export function getDeviceCount() {
  return request({
    url: '/iot/index/statistics/deviceCount',
    method: 'post'
  })
}

export function getAlarmChartStatistics(data) {
  return request({
    url: '/iot/index/statistics/alarmChartStatistics',
    method: 'post',
    data: data
  })
}

export function getAlarmList(data) {
  return request({
    url: '/iot/index/statistics/alarmList',
    method: 'post',
    params: data
  })
}

export function ignoreAlarmLog(data) {
  return request({
    url:'/iot/index/statistics/ignoreAlarmLog',
    method:'post',
    data:data
  })
}
